import { isPerNightPriceType } from '../price-type';

import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

export const PRICE_POLICY = {
  TAXES_NOT_INCLUDED: 'TAXES_NOT_INCLUDED',
  TAXES_INCLUDED: 'TAXES_INCLUDED',
  FEES_INCLUDED: 'FEES_INCLUDED',
};

export const FEES_KEYS = [
  'uncategorized',
  'payment_fees',
  'resort_fees',
  'service_charges',
];

/*
 * Maps from an array that Bellboy returns as `results.price_includes` to
 * a tax policy enum we can work with.
 */

export const isTaxesFeesIncluded = (pricePolicy?: string) =>
  pricePolicy === PRICE_POLICY.TAXES_INCLUDED;

export const isTaxesFeesNotIncluded = (pricePolicy?: string) =>
  pricePolicy === PRICE_POLICY.TAXES_NOT_INCLUDED;

export const isFeesIncluded = (pricePolicy?: string) =>
  pricePolicy === PRICE_POLICY.FEES_INCLUDED;

export const getPricePolicy = (priceIncludes?: Nullable<string[]>) => {
  if (!priceIncludes) return null;

  if (priceIncludes.length === 0) {
    return PRICE_POLICY.TAXES_NOT_INCLUDED;
  }
  if (priceIncludes.every((key) => FEES_KEYS.includes(key))) {
    return PRICE_POLICY.FEES_INCLUDED;
  }
  return PRICE_POLICY.TAXES_INCLUDED;
};

export const getPricePolicyText = ({
  i18n,
  pricePolicyType,
  priceType,
}: {
  pricePolicyType: string;
  i18n: I18nService;
  priceType: string;
}) => {
  if (isTaxesFeesIncluded(pricePolicyType) || !isPerNightPriceType(priceType)) {
    return i18n.translate('OTARates_TaxesIncluded');
  }

  if (pricePolicyType === PRICE_POLICY.FEES_INCLUDED) {
    return i18n.translate('OTARates_TaxesExcluded_Only');
  }

  return i18n.translate('dayview_taxes_not_included');
};
